// Tapping your own figure opens your pack instead of walking you onto the spot you already stand on. Each renderer
// records where it drew you this frame (feet, head and half width, in canvas pixels) and asks `tapsSelf` on a tap.
// A finger gets a generous pad around the figure; a mouse gets a smaller one.

/** Where your figure is on screen this frame: feet at (sx, sy), head top at `top`, half width `r` (canvas px). */
export interface SelfBox { sx: number; sy: number; top: number; r: number }

/** Extra pixels around the figure that still count as a tap on it. */
export const SELF_PAD_TOUCH = 22
export const SELF_PAD_MOUSE = 8
/** The figure is never narrower than this on screen for hit testing (half width), however far out you zoom. */
export const SELF_MIN_HALF = 14
/** Nor shorter than this (px from feet to head). */
export const SELF_MIN_TALL = 36

export function tapsSelf(box: SelfBox | null | undefined, px: number, py: number, coarse = false): boolean {
  if (!box || !Number.isFinite(box.sx) || !Number.isFinite(box.sy)) return false
  const pad = coarse ? SELF_PAD_TOUCH : SELF_PAD_MOUSE
  const half = Math.max(box.r, SELF_MIN_HALF) + pad
  const top = Math.min(box.top, box.sy - SELF_MIN_TALL) - pad
  return Math.abs(px - box.sx) <= half && py >= top && py <= box.sy + pad
}

/** True on a touch-first screen (phone, tablet, the car), where taps get the bigger pad. */
export const coarsePointer = (): boolean => !!globalThis.window?.matchMedia?.('(pointer: coarse)').matches
